import axios from 'axios';

const IDAMAN_AUTHORIZE_URL = process.env.REACT_APP_IDAMAN_AUTHORIZE_URL;
const IDAMAN_TOKEN_URL = process.env.REACT_APP_IDAMAN_TOKEN_URL;
const IDAMAN_CLIENT_ID = process.env.REACT_APP_IDAMAN_CLIENT_ID;
const IDAMAN_REDIRECT_URI = process.env.REACT_APP_IDAMAN_REDIRECT_URI;
const IDAMAN_AUTHORIZE_SCOPE = 'openid profile api.auth user.role user.read user.readAll';
const IDAMAN_TOKEN_SCOPE = 'api.auth user.role user.read user.readAll position.read position.readAll';

export function buildAuthorizeUrl(state, codeChallenge) {
  const params = new URLSearchParams({
    client_id: IDAMAN_CLIENT_ID,
    redirect_uri: IDAMAN_REDIRECT_URI,
    response_type: 'code',
    scope: IDAMAN_AUTHORIZE_SCOPE,
    state,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
    response_mode: 'query',
    prompt: 'login',
  });
  return `${IDAMAN_AUTHORIZE_URL}?${params.toString()}`;
}

const idamanAxios = axios.create();

export async function exchangeCodeForToken(code, codeVerifier) {
  const params = new URLSearchParams({
    client_id: IDAMAN_CLIENT_ID,
    scope: IDAMAN_TOKEN_SCOPE,
    grant_type: 'authorization_code',
    redirect_uri: IDAMAN_REDIRECT_URI,
    code,
    code_verifier: codeVerifier,
  });

  const response = await idamanAxios.post(IDAMAN_TOKEN_URL, params.toString(), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });

  return response.data;
}
